// extracted by mini-css-extract-plugin
export default {"root":"ProjectAbout_root__-fK6l","archive":"ProjectAbout_archive__B9RmP","variation":"ProjectAbout_variation__FChEU"};